import { render, staticRenderFns } from "./r-item-recipe-page.vue?vue&type=template&id=7b919af1"
import script from "./r-item-recipe-page.vue?vue&type=script&lang=js"
export * from "./r-item-recipe-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b919af1')) {
      api.createRecord('7b919af1', component.options)
    } else {
      api.reload('7b919af1', component.options)
    }
    module.hot.accept("./r-item-recipe-page.vue?vue&type=template&id=7b919af1", function () {
      api.rerender('7b919af1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item-recipe/r-item-recipe-page.vue"
export default component.exports